import React from 'react';
import { Col, Row } from 'reactstrap';

import ApplyCouponContainer from '../../containers/AccountSettingsContainer/applyCouponContainer';
import CustomSyncContainer from '../../containers/AccountSettingsContainer/customSyncContainer';
// import NotificationPreferencesContainer from '../../containers/AccountSettingsContainer/notificationPreferencesContainer';
import DisabledOrFavoriteQuestions from '../../containers/AccountSettingsContainer/disabledQuestionsContainer';
import ManageSubscription from '../../containers/AccountSettingsContainer/manageSubscriptionContainer';
import MyFriendsContainer from '../../containers/AccountSettingsContainer/MyFriendsContainer';
import MyProfile from '../../containers/AccountSettingsContainer/myProfileContainer';
import CustomeSiteMockUp from './customerSiteMockup/customerSiteMockUpView';
import LinkCardsView from './LinkCards/linkCardsView';

class AccountSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  // This is not correct but is done this way because the user is not persisted in the local storage,
  UNSAFE_componentWillReceiveProps(props) {
    if (props.user.id && this.state.loading) {
      // the getCustomerSiteMockUp is related to the "want swag" functionality that was hidden
      // if functionality is restored, uncomment this line.
      // this.props.getCustomerSiteMockUp(props.user.id);
      this.props.getLastCouponUserAction(props.user.id);
      this.setState({
        loading: !this.state.loading,
      });
    }
  }

  render() {
    return (
      <Row className="account-settings-page mx-0">
        <Col sm={12} lg={8}>
          <MyProfile
            getAvailableQualForDailyQuiz={
              this.props.getAvailableQualForDailyQuiz
            }
            availableQualForDailyQuiz={this.props.availableQualForDailyQuiz}
            updateUserSettingQualForDailyQuiz={
              this.props.updateUserSettingQualForDailyQuiz
            }
            userSettingQualForDailyQuizMessage={
              this.props.userSettingQualForDailyQuizMessage
            }
            loadingUpdateUserSettingQualForDailyQuiz={
              this.props.loadingUpdateUserSettingQualForDailyQuiz
            }
            setUserSettingQualForDailyQuizMessage={
              this.props.setUserSettingQualForDailyQuizMessage
            }
            flashChoose={this.props.flashChoose}
            setFlashSectionChoose={this.props.setFlashSectionChoose}
          />

          <div id="customerSite">
            <CustomeSiteMockUp
              setCustomerSiteMockUp={this.props.setCustomerSiteMockUp}
              customerMessage={this.props.customerMessage}
              customerSiteMockUp={this.props.customerSiteMockUp}
              setCustomerMessage={this.props.setCustomerMessage}
              loadingCustomerSite={this.props.loadingCustomerSite}
              user={this.props.user}
              getCustomerSiteMockUp={this.props.getCustomerSiteMockUp}
            />
          </div>
          <CustomSyncContainer />
          <LinkCardsView />
          <MyFriendsContainer />
          {/* <NotificationPreferencesContainer /> */}
          <DisabledOrFavoriteQuestions
            title="Disabled Questions"
            favorite={false}
            userId={this.props.user.id}
          />
          <DisabledOrFavoriteQuestions
            title="Favorite Questions"
            favorite
            userId={this.props.user.id}
          />
        </Col>
        <Col sm={12} lg={4}>
          <ManageSubscription />
          {!this.props.user?.isGuestAccount &&
            !this.props.user?.guestAccountScheduledStart && (
              <ApplyCouponContainer />
            )}
        </Col>
      </Row>
    );
  }
}

export default AccountSettings;
